import React, { useEffect, useState, useRef } from "react";

const LeaveRequestsListController = (onRefresh, leaveRequestsList) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const leaveRequestInfoRef = useRef(null);
  const [isViewLeaveRequestModalOpen, setIsViewLeaveRequestModalOpen] = useState(false);
  const viewLeaveRequestInfoRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(leaveRequestsList?.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentRequests = leaveRequestsList?.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
    // setLoading(true);

  }, []);

  const [expandedRows, setExpandedRows] = useState({});
  const toggleExpand = (key) => {
    setExpandedRows((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const [daysExpandedRows, setDaysExpandedRows] = useState({});
  const daysToggleExpand = (index) => {
    setDaysExpandedRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const [datesExpandedRows, setDatesExpandedRows] = useState({});
  const datesToggleExpand = (index) => {
    setDatesExpandedRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const handleAddLeaveRequest = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleViewLeaveRequestClick = (request) => {
    viewLeaveRequestInfoRef.current = request;
    setIsViewLeaveRequestModalOpen(true);
  };

  const handleCloseViewLeaveRequestModal = () => {
    setIsViewLeaveRequestModalOpen(false);
  };

  const handleEditLeaveRequest = (request) => {
    leaveRequestInfoRef.current = request;
    setIsModalOpen(true);
  };

  const getStatusStyle = (approval_status_name) => {
    const status = approval_status_name?.toLowerCase();
    switch (status) {
      case "approved":
        return { backgroundColor: "#1A932E2E", color: "#1A932E" };
      case "rejected":
        return { backgroundColor: "#C7C4C32E", color: "#7B7B7B" }; // Gray
      case "approval pending":
        return { backgroundColor: "#EE201C2E", color: "#EE201C" };
      case "partially approved":
        return { backgroundColor: "#fff3cd", color: "#DFA510" }; // Yellow
      // return { backgroundColor: "#E65F2B2E", color: "#E65F2B" };
      default:
        return {};
    }
  };

  const OnAddUpdateSuccess = () => {
    if (onRefresh) {
      onRefresh();
    }
  }

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const maxVisiblePages = 3;

  const getVisiblePages = () => {
    const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    // Adjust startPage if we're near the end
    const adjustedStartPage = Math.max(1, endPage - maxVisiblePages + 1);

    return Array.from({ length: endPage - adjustedStartPage + 1 }, (_, index) => adjustedStartPage + index);
  };

  const visiblePages = getVisiblePages();

  return {
    isModalOpen,
    handleAddLeaveRequest,
    handleCloseModal,
    getStatusStyle,
    handleEditLeaveRequest,
    leaveRequestInfoRef,
    OnAddUpdateSuccess,
    loading,
    error,
    currentPage,
    totalPages,
    handlePageChange,
    currentRequests,
    isViewLeaveRequestModalOpen,
    handleViewLeaveRequestClick,
    viewLeaveRequestInfoRef,
    visiblePages,
    expandedRows, toggleExpand,
    daysExpandedRows, daysToggleExpand,
    datesExpandedRows, datesToggleExpand
  };
};

export default LeaveRequestsListController;
